<div mat-dialog-title class="dialog-title">
    <h2>Select Geofences</h2>
    <div class="actions">
        <button mat-button color="lightGreen" type="button" (click)="selectAll()">Select All</button>
        <button mat-button color="lightGreen" type="button" (click)="selectNone()">Select None</button>
    </div>
</div>
<div mat-dialog-content class="dialog-content">
    <div class="buttons">
        <mat-checkbox
        *ngFor="let geo of geofences"
        [checked]="isSelected(geo)"
        color="lightGreen"
        (change)="toggleSelect(geo)"
        >{{ geo.name }}</mat-checkbox
        >
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button color="lightGreen" type="submit" (click)="done()">Done</button>
</div>